export function LocalTimeConverter(date){
    const now = new Date(date);
    const offsetMinutes = now.getTimezoneOffset();
    const adjustedDate = new Date(now.getTime() - offsetMinutes * 60 * 1000)
        .toISOString()
        .substring(0, 16);
        return adjustedDate
}